import service from './service'

export default {
	reportPrint: ({ source, message }) =>
		service.post('/back/log/print', { source, message }),
}
